import axios from "axios";
import {findChatRoomHelper, findChatRoomMessageHelper, findChatRoomMessageReactionHelper} from '@/store/modules/helpers/helpers.js';
import moment from 'moment'
import $store from '@/store'
import _ from 'lodash';

const state = {
	rooms: [],
	quickmenu: false,
	popupWidth: 380,
	popupPadding: 20,
	totalExpandedWidth: 0,
	popupRoomNotFitting: null,
	newMessagePopup: false,
	bubblesEnabled: true,
	loadingRooms: false,
	tab: 'private',
	whisperingUsers: [],
	whisperTimeout: 10
	// Rooms in bubble
};

const getters = {
	whisperingUsers: state => {
		return state.whisperingUsers;
	},
	whisperTimeout: state => {
		return state.whisperTimeout;
	},
	tab: state => {
		return state.tab;
	},
	loadingRooms: state => {
		return state.loadingRooms;
	},
	bubblesEnabled: state => {
		return state.bubblesEnabled;
	},
	newMessagePopup: state => {
		return state.newMessagePopup
	},
	rooms: state => {
		return state.rooms
	},
	bubbleRooms: state => {
		return state.rooms.filter(x => x.bubble);
	},
	bubbleRoomsExpanded: state => {
		return state.rooms.filter(x => x.bubble && x.bubble_expanded);
	},
	quickmenu: state => {
		return state.quickmenu;
	},
	popupWidth: state => {
		return state.popupWidth;
	},
	popupPadding: state => {
		return state.popupPadding;
	},
	totalExpandedWidth: state => {
		return state.totalExpandedWidth;
	},
	popupRoomNotFitting: state => {
		return state.popupRoomNotFitting;
	},
	activeBubble: state => {
		let x = state.rooms.find(x => x.bubble && x.bubble_expanded && x.bubble_active);
		return x;
	},
	unreadMessagesCount: state => {
		let cnt = 0;
		state.rooms.forEach(room => {
			cnt += room.unread_messages_count;
		})
		return cnt;
	},
	allMessages: state => {
		let cnt = 0;
		state.rooms.forEach(room => {
			cnt += room.room_messages_count;
		})
		return cnt;
	},
};

const mutations = {
	addWhisperingUser(state, payload) {
		const idx = state.whisperingUsers.findIndex(x => x.user_id == payload.user_id);
		payload.clock = $store.getters['application/clock'];
		if(idx != -1) {
			state.whisperingUsers.splice(idx, 1);
		}
		state.whisperingUsers.push(payload);
	},
	removeWhisperingUser(state, payload) {
		const idx = state.whisperingUsers.findIndex(x => x.user_id == payload.user_id && x.where == payload.where && x.chat_room_id == payload.chat_room_id);
		if(idx != -1) {
			state.whisperingUsers.splice(idx, 1);
		}
	},
	setTab(state, payload) {
		state.tab = payload;
	},
	setLoadingRooms(state, payload) {
		state.loadingRooms = payload;
	},
	enableBubbles(state) {
		state.bubblesEnabled = true;
	},
	disableBubbles(state) {
		state.rooms.forEach(x => {
			x.bubble = false;
			x.bubble_added = 0;
			x.bubble_active = false;
			x.bubble_expanded = false;
		})
		state.bubblesEnabled = false;

	},
	openNewMessagePopup(state) {
		state.newMessagePopup = true;
	},
	closeNewMessagePopup(state) {
		state.newMessagePopup = false;
	},
	setPopupRoomNotFitting(state, payload) {
		state.popupRoomNotFitting = payload;
		return true;
	},
	setTotalExpandedWidth(state, payload) {
		state.totalExpandedWidth = payload;
		return true;
	},
	setQuickmenu(state, payload) {
		state.quickmenu = payload;
		return true;
	},
	setRooms(state, payload) {
		payload.forEach(x => {
			if(state.rooms.indexOf(x => x.id == payload.id) == -1) {
				x.bubble = false;
				x.bubble_added = 0;
				x.bubble_active = false;
				x.bubble_expanded = false;
				x.messages = null;
				state.rooms.push(x);
			}
		});
    },
	addRoom(state, payload) {
		let idx = state.rooms.findIndex(x => x.id == payload.id);
		if(idx == -1) {
			let data = Object.assign({}, payload);
			data.bubble = false;
			data.bubble_added = 0;
			data.bubble_active = false;
			data.bubble_expanded = false;
			state.rooms.push(data);
			console.log("ROOM ADDED DATA", data)
		}
	},
	refreshRoom(state, payload) {

		let idx = state.rooms.findIndex(x => x.id == payload.id);
		if(idx != -1) {
			state.rooms.splice(idx, 1);
			let data = Object.assign({}, payload);
			data.bubble = false;
			data.bubble_added = 0;
			data.bubble_active = false;
			data.bubble_expanded = false;
			state.rooms.push(data);
			console.log("ROOM REFRESHED DATA", data)
		}
	},
	removeRoom(state, payload) {
		let idx = state.rooms.findIndex(x => x.id == payload.id);
		if(idx != -1) {
			state.rooms.splice(idx, 1);
		}
	},
	addBubble(state, payload) {
		if(state.bubblesEnabled) {
			let room = findChatRoomHelper(state, payload.id);
			if(room && !room.bubble) {
				room.bubble = true;
				room.bubble_added = Math.round((new Date()).getTime() / 1000);
				room.bubble_active = true;
			}
		}
	},
	removeBubble(state, payload) {
		if(state.bubblesEnabled) {
			let room = findChatRoomHelper(state, payload.id);
			if(room) {
				room.bubble = false;
				room.bubble_expanded = false;
			}
		}
	},
	expandBubble(state, payload) {
		if(state.bubblesEnabled) {
			let room = findChatRoomHelper(state, payload.id);
			if(room && !room.bubble_expanded) {
				room.bubble = true;
				room.bubble_expanded = true;
			}
		}

	},
	setBubbleActive(state, payload) {
		if(state.bubblesEnabled) {
			state.rooms.forEach(x => {
				if(x.id == payload.id) {
					x.bubble_active = true;
				}
				else {
					x.bubble_active = false;
				}
			})
		}
	},
	setBubbleInactive(state, payload) {
		if(state.bubblesEnabled) {
			let room = findChatRoomHelper(state, payload.id);
			if(room && room.bubble) {
				room.bubble_active = false;
			}
		}
	},
	minimizeBubble(state, payload) {
		if(state.bubblesEnabled) {
			let room = findChatRoomHelper(state, payload.id);
			if(room) {
				room.bubble_expanded = false;
				room.bubble_active = false;
			}
		}
	},
	setRoom(state, payload) {
		let room = findChatRoomHelper(state, payload.id);
		if(room) {
			Object.keys(payload).forEach(key => {
				room[key] = payload[key];
			});
			return true;
		}
		return false;
	},
	addNewMessage(state, payload) {
		let room = findChatRoomHelper(state, payload.chat_room_id);
		if(room) {
			if(room?.messages?.data) {
				if(room.messages.data.findIndex(x => x.id == payload.id) == -1) {
					room.messages.data.push(payload);
				}
			}
			if(room.is_public) {
				if(payload.user.id != $store.getters['auth/user'].id && payload.created_at > room.last_presence_at) {
					room.unread_messages_count++;
				}
			}
			else {
				let status = payload.delivery_statuses.find(d => d.recipient_user_id == $store.getters['auth/user'].id);
				if(status && status.read_at) {
					room.unread_messages_count++;
				}
			}


			room.updated_at = moment().utc().format('YYYY-MM-DD HH:MM:SS');

			// Stop propagating whispering of user who just sent message
			// state.whisperingUsers.findIndex(x => x.user_id == payload.user_id && x.where == payload.where && x.chat_room_id == payload.chat_room_id);
			$store.commit('chat/removeWhisperingUser', {
				user_id: payload.user.id,
				where: 'chat',
				chat_room_id: payload.chat_room_id,
				// last user clock!
			})
			return true;
		}

		return false;
	},
	removeMessage(state, payload) {
		let room = findChatRoomHelper(state, payload.chat_room_id);
		if(room && room.messages && room.messages.data) {
			let idx = room.messages.data.findIndex(x => x.id == payload.id);
			if(idx != -1) {
				let isLast = false;
				if(payload.id == _.maxBy(room.messages.data, 'id').id) {
					isLast = true;
				}
				room.messages.data.splice(idx, 1);
				if(isLast) {
					room.latest_message = _.maxBy(room.messages.data, 'id');
				}
				return true;
			}
		}
		return false;
	},
	appendMessage(state, payload) {
		console.log("SHOULD APPEND MESSAGE PAYLOAD", payload)
		let room = findChatRoomHelper(state, payload.chat_room_id);
		// Check delivery statuses
		if(room) {
			if(!room.is_public) {
				if(payload.delivery_statuses) {
					let x = payload.delivery_statuses.find(d => d.recipient_user_id == $store.getters['auth/user'].id);
					if(x && !x.read_at) {
						console.log("SHOULD HERE!!!!", x)
						room.unread_messages_count++;
					}
				}
			}
			else {
				if(payload.user.id != $store.getters['auth/user'].id && payload.created_at > room.last_presence_at) {
					room.unread_messages_count++;
				}
			}
		}


		if(room && room.messages && room.messages.data) {
			if(room.messages.data.findIndex(x => x.id == payload.id) == -1) {
				room.messages.data.push(payload);
				console.log("FINAL ROOM AFTER ADDING MESSAGE", room)
				return true;
			}
		}
		return false;
	},
	setMessage(state, payload) {
		let message = findChatRoomMessageHelper(state, payload.chat_room_id, payload.id);
		if(message) {
			Object.keys(payload).forEach(key => {
				message[key] = payload[key];
			});

			// Is last
			let room = findChatRoomHelper(state, payload.chat_room_id);
			if(room && payload.id == _.maxBy(room.messages.data, 'id').id) {
				room.latest_message = message;
			}

			return true;
		}
		return false;
	},
	setMessageReaction(state, payload) {
		let reaction = findChatRoomMessageReactionHelper(state, payload.chat_room_id, payload.message_id, payload.reaction.id);
		if(reaction) {
			reaction = payload.reaction;
			return true;
		}
		return false;
	},
	setMessagesMeta(state, payload) {
		let room = findChatRoomHelper(state, payload.id);
		if(room) {
			let data = Object.assign({}, payload);
			delete data.id;
			if(room.messages) {
				room.messages.meta = data;
				return true;
			}
		}
		return false;
	},
	setRoomReadByMe(state, payload) {
		// id, user_id
		let room = findChatRoomHelper(state, payload.id);
		if(room) {
			room.unread_messages_count = 0;
		}
	},
	setUserMessagesRead(state, payload) {
		// room_id, user_id
		let room = findChatRoomHelper(state, payload.chat_room_id);
		if(room && room.messages && room.messages.data) {
			room.messages.data.forEach(message => {
				message.delivery_statuses.forEach(d => {
					if(d.recipient_user_id == payload.user_id && !d.read_at) {
						d.read_at = moment().utc();
						if(d.recipient_user_id == $store.getters['auth/user'].id && room.unread_messages_count > 0) {
							room.unread_messages_count --;
						}
					}
				})
			})
		}
	},
	setRoomMessagesRead(state, payload) {
		let room = findChatRoomHelper(state, payload.chat_room_id);
		if(room && room.messages && room.messages.data) {
			room.messages.data.forEach(message => {
				message.delivery_statuses.forEach(d => {
					if(!d.read_at) {
						if(payload.user_id && payload.user_id == d.recipient_user_id) {
							d.read_at = moment().utc();
						}
					}
				})
			})
		}
	},
	setMessageRead(state, payload) {
		let room = findChatRoomHelper(state, payload.chat_room_id);
		if(room && room.messages && room.messages.data) {
			room.messages.data.forEach(message => {
				let shouldDecrement = false;
				message.delivery_statuses.forEach(d => {
					if(d.chat_message_id == payload.id && !d.read_at) {
						if(payload.user_id && payload.user_id == d.recipient_user_id) {
							d.read_at = moment().utc();
						}
						if(d.recipient_user_id == $store.getters['auth/user'].id) {
							shouldDecrement = true;
						}
					}
				})
				if(shouldDecrement && room.unread_messages_count > 0) {
					room.unread_messages_count--;
				}
			})
		}
	},
	setLatestMessage(state, payload) {
		let room = findChatRoomHelper(state, payload.chat_room_id);
		if(room) {
			room.latest_message = payload;
			room.latest_message.attachments_count = payload.attachments.length;
			room.latest_message.images_count = payload.images.length;
		}
	},
	appendReactionToMessage(state, payload) {
		let message = findChatRoomMessageHelper(state, payload.message.chat_room_id, payload.message.id);
		if(message) {
			let idx = message.reactions.findIndex(x => x.id == payload.reaction.id);
			if(idx == -1) {
				// Add
				message.reactions.push(payload.reaction);
				message['reactions_' + payload.reaction.type + '_count']++;
				message.reactions_count++;
			}
			else {
				// Edit
				if(message.reactions[idx].type != payload.reaction.type) {
					message['reactions_' + message.reactions[idx].type + '_count']--;
					message['reactions_' + payload.reaction.type + '_count']++;
				}
				message.reactions.splice(idx, 1);
				message.reactions.push(payload.reaction);
			}

			if($store.getters['auth/user'].id == payload.reaction.user.id) {
				message.my_reaction = payload.reaction;
			}
		}
	},
	removeReactionFromMessage(state, payload) {
		let message = findChatRoomMessageHelper(state, payload.message.chat_room_id, payload.message.id);
		if(message) {
			let idx = message.reactions.findIndex(x => x.id == payload.reaction.id);
			if(idx != -1) {
				message.reactions.splice(idx, 1);
				message['reactions_' + payload.reaction.type + '_count']--;
				message.reactions_count--;

				if($store.getters['auth/user'].id == payload.reaction.user.id) {
					message.my_reaction = null;
				}
			}
		}
	},
	setMessageMyReaction(state, payload) {
		let message = findChatRoomMessageHelper(state, payload.chat_room_id, payload.message_id);
		if(message) {
			if(!message.my_reaction) {
				message['reactions_' + payload.reaction.type + '_count']++;
			}
			else {
				if(message.my_reaction.type != payload.reaction.type) {
					message['reactions_' + message.my_reaction.type + '_count']--;
					message['reactions_' + payload.reaction.type + '_count']++;
				}
			}
			message.my_reaction = payload.reaction;
		}
	},
	removeImage(state, payload) {
		let message = findChatRoomMessageHelper(state, payload.message.chat_room_id, payload.message.id);
		if(message) {
			let idx = message.images.findIndex(x => x.id == payload.image.id);
			if(idx != -1) {
				message.images.splice(idx, 1);

				let room = findChatRoomHelper(state, payload.message.chat_room_id);

				if(payload.message.id == _.maxBy(room.messages.data, 'id').id) {
					room.latest_message.images_count --;
				}

				return true;
			}
		}
		return false;
	},
	removeAttachment(state, payload) {
		let message = findChatRoomMessageHelper(state, payload.message.chat_room_id, payload.message.id);
		if(message) {
			let idx = message.attachments.findIndex(x => x.id == payload.attachment.id);
			if(idx != -1) {
				message.attachments.splice(idx, 1);

				let room = findChatRoomHelper(state, payload.message.chat_room_id);
				if(payload.message.id == _.maxBy(room.messages.data, 'id').id) {
					room.latest_message.attachments_count --;
				}
				return true;
			}
		}
		return false;
	},
	addUsersToRoom(state, payload) {
		let room = findChatRoomHelper(state, payload.chat_room_id);
		if(room) {
			if(payload.users ) {
				payload.users.forEach(user => {
					if(room.users.findIndex(x => x.id == user.id) == -1) {
						room.users.push(user);
					}
				});
			}
			if(room.users) {
				room.users_count = room.users.length;
			}
		}


	}
}

const actions = {
	/*
	async upload({commit}, payload) {

	}
	*/
	/* eslint-disable */
	async createRoom({commit}, payload) {
		let res = {};

		await axios.post('chat/rooms', payload)
			.then(response => {
				commit('addRoom', response.data.data);
				res = {
					success: true,
					error: false,
					data: response.data.data
				};
			})
			.catch(error => {
				res = {
					success: false,
					error: error,
					data: null
				}
			})

		return res;
	},

	async inviteUsers({commit}, payload) {
		//api/chat/rooms/{chatRoom}/invite
		let res = {};
		await axios.post(`chat/rooms/${payload.chat_room_id}/invite`, {
			user_ids: payload.user_ids
		})
		.then(response => {
			res = {
				success: true,
				error: false,
				data: response.data.data
			}
		})
		.catch(error => {
			res = {
				success: false,
				error: error,
				data: null
			}
		})
		return res;
	},

	async setRoomReadByMe({commit}, payload) {
		let res = {};
		await axios.post(`chat/rooms/${payload.id}/set-read`)
			.then(response => {
				commit('setRoomReadByMe', {id: payload.id});
				commit('setUserMessagesRead', {
					chat_room_id: payload.id,
					user_id: $store.getters['auth/user'].id
				})
				res = {
					success: true,
					error: false,
					data: response.data.data
				}
			})
			.catch(error => {
				res = {
					success: false,
					error: true,
					data: error
				}
			})
		return res;
	},
	async getRoom({commit, state}, payload) {
		let res = {};
		let params = Object.assign({}, payload);
		await axios.get(`chat/rooms/${payload.hash}`, {
			params
		})
		.then(response => {
			const room = findChatRoomHelper(state, response.data.data.id)
			if(payload.refresh) {
				commit('refreshRoom', response.data.data);
			}
			else {
				if(room) {
					if(params.page && params.page != 1) {
						let meta = Object.assign({}, response.data.data.messages.meta);
						meta.id = response.data.data.id;

						response.data.data.messages.data.forEach(x => {
							commit('appendMessage', x);
						});
						commit('setMessagesMeta', meta);
					}
					else {
						commit('setRoom', response.data.data)
					}
				}
				else {
					commit('addRoom', response.data.data);
				}
			}


			res = {
				success: true,
				error: false,
				data: response.data
			}
		})
		.catch(error => {
			res = {
				success: false,
				error: error,
				data: null
			}
		});
		return res;
	},
	/* eslint-enable */

	async getRooms({commit}, payload) {
		let res = {};
		await axios.get('chat/rooms', payload)
			.then(response => {
				commit('setRooms', response.data.data)
				res = {
					success: true,
					error: false,
					data: response.data.data
				}
			})
			.catch(error => {
				res = {
					success: false,
					error: error,
					data: null
				};
			});
			return res;
	},

	/* eslint-disable */
	async sendMessage({commit}, payload) {
		let res = {};
		let url = 'chat/messages';
		if(payload.chat_room_id) {
			url += '/' + payload.chat_room_id;
		}
		await axios.post(url, payload)
			.then(response => {
				console.log("MESSAGE SENT!", response.data.data)
				commit('appendMessage', response.data.data);
				commit('setLatestMessage', response.data.data);
				res = {
					success: true,
					error: false,
					data: response.data.data
				}
			})
			.catch(error => {
				res = {
					success: false,
					error: error,
					data: null
				};
			});
		return res;
	},

	async getMessage({commit, dispatch}, payload) {
		let res = {};
		await axios.get(`chat/messages/${payload.id}`, payload)
			.then(async (response) => {
				let room = findChatRoomHelper(state, response.data.data.chat_room_id);
				if(room) {
					commit('addNewMessage', response.data.data);
					commit('addBubble', {id: response.data.data.chat_room_id});
					commit('expandBubble', {id: response.data.data.chat_room_id});
				}
				else {
					// Get room
					let r = await dispatch('getRoom', {hash: response.data.data.chat_room_hash});
					if(r.success) {
						setTimeout(() => {
							commit('addBubble', {id: r.data.data.id});
							commit('expandBubble', {id: r.data.data.id})
						}, 300)
					}
				}

				res = {
					success: true,
					error: false,
					data: response.data.data
				}
			})
			.catch(error => {
				res = {
					success: false,
					error: error,
					data: null
				};
			});

			return res;
	},

	async setMessageRead({commit}, payload) {
		// room_id, id
		let res = {};
		await axios.post(`chat/messages/${payload.id}/set-read`)
			.then(response => {
				commit('setMessageRead', {
					chat_room_id: payload.chat_room_id,
					id: payload.id
				});
				res = {
					success: true,
					error: false,
					data: response.data.data
				}
			})
			.catch(error => {
				res = {
					success: false,
					error: error,
					data: null
				};
			})
		return res;
	},
	async editMessage({commit}, payload) {
		let res = {};
		await axios.patch(`/chat/messages/${payload.id}`, payload.data)
			.then(response => {
				commit('setMessage', response.data.data);
				res = {
					success: true,
					error: false,
					data: response.data.data
				}
			})
			.catch(error => {
				res = {
					success: false,
					error: error,
					data: null
				};
			});
		return res;
	},
	async deleteMessage({commit}, payload) {
		let res = {};

		await axios.delete(`/chat/messages/${payload.id}`, payload.data)
			.then(response => {
				commit('removeMessage', payload);
				res = {
					success: true,
					error: false,
					data: response.data.data
				}
			})
			.catch(error => {
				res = {
					success: false,
					error: error,
					data: null
				};
			});
		return res;
	},

	async handleEvent({commit, dispatch, state}, payload) {
		const auth = payload.auth;
		const event = payload.event;
		const roomId = event.chat_room_id;
		const roomHash = event.room_hash;

		let engage = true;
		if(event._event_token && window._event_token) {
			if(event._event_token == window._event_token) {
				engage = false;
			}
		}
		let roomLoaded = false;
		let room = findChatRoomHelper(state, roomId);
		if(room && room.messages) {
			roomLoaded = true;
		}

		if(event.event == 'chat_message_added' && engage) {
			let res = await dispatch('getMessage', {id: event.chat_message_id});
			if(res.success) {
				commit('setLatestMessage', res.data);
			}
		}
		if(event.event == 'chat_message_read') {
			commit('setMessageRead', {
				chat_room_id: event.chat_room_id,
				id: event.what_id,
				user_id: event.event_user_id // By who?
			})
		}
		if(event.event == 'chat_room_read_messages') {
			commit('setRoomMessagesRead', {
				chat_room_id: event.chat_room_id,
				user_id: event.event_user_id // By who?
			})
		}
		if(event.event == 'chat_message_updated' && engage) {
			let res = await dispatch('getMessage', {id: event.chat_message_id});
			if(res.success) {
				commit('setMessage', res.data);
			}
		}
		if(event.event == 'chat_message_removed' && engage) {
			commit('removeMessage', {
				id: event.chat_message_id,
				chat_room_id: event.chat_room_id
			});
		}
		if(event.event == 'chat_message_reaction_added' && engage) {
			payload = {
				message: {
					id: event.chat_message_id,
					chat_room_hash: event.chat_room_hash,
					chat_room_id: event.chat_room_id,
				},
				reaction: {
					id: event.what_id,
					type: event.reaction_type,
					user: {
						id: event.what_user_id
					}
				}
			};
			commit('appendReactionToMessage', payload);
		}
		if(event.event == 'chat_message_reaction_updated' && engage) {
			payload = {
				message: {
					id: event.chat_message_id,
					chat_room_hash: event.chat_room_hash,
					chat_room_id: event.chat_room_id,
				},
				reaction: {
					id: event.what_id,
					type: event.reaction_type,
					user: {
						id: event.what_user_id
					}
				}
			};
			commit('appendReactionToMessage', payload);
		}
		if(event.event == 'chat_message_reaction_removed' && engage) {
			payload = {
				message: {
					id: event.chat_message_id,
					chat_room_hash: event.chat_room_hash,
					chat_room_id: event.chat_room_id,
				},
				reaction: {
					id: event.what_id,
					type: event.reaction_type,
					user: {
						id: event.what_user_id
					}
				}
			};
			commit('removeReactionFromMessage', payload);
		}
		if(event.event == 'chat_message_file_removed' && engage) {
			// removeAttachment
			payload = {
				message: {
					id: event.chat_message_id,
					chat_room_hash: event.chat_room_hash,
					chat_room_id: event.chat_room_id,
				},
				attachment: {
					id: event.file_id,
				}
			};
			if(event.file_for == 'chat_attachment') {
				payload.attachment = {id: event.file_id}
				commit('removeAttachment', payload)
			}
			else if(event.file_for == 'chat_image') {
				payload.image = {id: event.file_id};
				commit('removeImage', payload)
			}

		}
		if(event.event == 'chat_room_invite_user') {
			// Add user to room

			// TODO: If auth user is user beeing invited, get new room, else get that user and add him to room
			await axios.get(`chat/rooms/${event.chat_room_hash}`)
				.then(response => {
					response.data.data?.users?.forEach(user => {
						if(user.id == event.what_user_id) {
							commit('addUsersToRoom', [user]);
						}
					})
					// what_user_id
				})
		}
		if(event.event == 'chat_room_added') {
			if(event.is_public) {
				// Get chat room
				let res = await dispatch('getRoom', {hash: event.chat_room_hash});
				return res;
			}
		}
	}
	/* eslint-enable */
}

export default {
    namespaced: true,
	state,
	getters,
	mutations,
    actions,
};
